'use strict';

/* Controllers */

app.controller('VenuesController', ['$scope', '$rootScope', '$location', 'Venue', 'User', 'Helper', 'Popup', '$window', 
    function ($scope, $rootScope, $location, Venue, User, Helper, Popup, $window) {

        // init scope services
        $scope.User = User;

        // init vars
        var pagination = { limit: 30, offset: -30 };
        var getting_more_results = false;
        var more_results_exist = true;

        // init scope vars
        $scope.venues = [];
        $scope.selectedUser = $rootScope.globals.selectedUser;
        $scope.first_loading = true;


        /**
         * infinit scroll triggers this function
         * to get more search results
         */
        $scope.getMoreResults = function(){
            // prevent multiple calls
            if(getting_more_results || !more_results_exist) return;
            getting_more_results = true;

            // update pagination offset
            pagination.offset = pagination.offset + pagination.limit;

            // get more results
            Venue.get($rootScope.globals.selectedUser, pagination, function(resp, status){

                if( status == 200){
                    $scope.venues = $scope.venues.concat( resp.data.venues );
                    more_results_exist = resp.pagination.next;
                }
                else if( status == 404 ){
                    if( $scope.venues.length == 0 ){
                        Popup.error(Helper.getProperty(resp, 'data.message'), function(){
                            $window.history.back();
                        });
                    }
                    else{
                        more_results_exist = false;
                    }
                }
                else if( status != 500 ){
                    Popup.error(Helper.getProperty(resp, 'data.message'));
                }
                else{
                    Popup.error('Something went wrong :(');
                }

                getting_more_results = false;
                $scope.first_loading = false;
            });
        }


        /**
         * select venue from results
         * 
         * @param Object  venue
         */
        $scope.selectVenue = function(venue){
            $rootScope.globals.selectedVenue = venue;

            // remember users selection after browser refresh
            Helper.updateLocalStorageWithGlobalVariable();

            $location.path('/menu');
        }


        // make initial request
        $scope.getMoreResults();
    }]);